function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage9JobSearchResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 44 44)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(255,192,97)",
      strokeWidth: 4,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 38
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.62 -8)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(251,0,126)",
      fillRule: "nonzero",
      opacity: 0.7
    },
    cx: 0,
    cy: 0,
    r: 11.0769
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.62 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,171,205)",
      fillRule: "nonzero",
      opacity: 0.7
    },
    cx: 0,
    cy: 0,
    r: 11.0769
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage9JobSearchResult);
export default __webpack_public_path__ + "static/media/image9 JobSearchResult.8c530ff6cb8b8e8dc0ff179c17ce3880.svg";
export { ForwardRef as ReactComponent };